import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryPressPage } from "@/strapiQuery/press";
import { PressPageContent } from "@/components/pages/press/Press";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const pressPageContentPromise = getStrapiEntity<PressPageContent>(
    "press",
    queryPressPage
  );

  const [layout, pressPageContent] = await Promise.all([
    layoutPromise,
    pressPageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      ...pressPageContent,
      intlMessages,
      defaultCanonicalRoute: routes.press,
    },
    revalidate: 10,
  };
};

export { Press as default } from "@/components/pages/press/Press";
